function isValidHttpUrl(string :string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;  
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

const resolveImgUrl = (url : string, thumbnail? : boolean)=>{
    if(isValidHttpUrl(url)) return url;
    else {
      const urlSplit = url.split('.');
      let imageSrc = url;
      if(thumbnail){
        imageSrc = `${urlSplit[0]}-thumb.${urlSplit[1]}`
      }
      return `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_BACKEND_IMG_ROOT}${imageSrc}`
    }
}

export default resolveImgUrl;